import { Modal, Text } from '@fozito/common-ui';
import { Form, Input } from 'antd';
import DollarAmountInput, { useDollarAmountInputRef } from 'modules/POS/Cashier/components/DollarAmount/Input';
import DollarAmountKeyboard from 'modules/POS/Cashier/components/DollarAmount/Keyboard';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import { IUISelectItem } from '../../cashier.interface';
import { delay } from 'lodash';

type QuickPayV2Props = {};
type Ref = {
  open: (data: IUISelectItem, callback: (data: IUISelectItem, price: number) => void) => void;
};
export const globalModalEditPriceItemRef = React.createRef<Ref>();
const ModalEditPriceItem = forwardRef<Ref, QuickPayV2Props>(({ }, ref) => {
  const [form] = Form.useForm();
  const inputRef = useDollarAmountInputRef();
  const callbackRef = useRef<(data: IUISelectItem, price: number) => void>(() => undefined);
  const [visible, setVisible] = useState(false);
  const onClose = () => setVisible(false);
  const onClear = () => form.resetFields(['amount']);
  const onOpen: Ref['open'] = (data, _callback) => {
    form.resetFields();
    setVisible(true);
    form.setFieldsValue(data);
    delay(() => inputRef.current?.focus(), 100);
    callbackRef.current = _callback || (() => undefined);
  };

  const handleFinish = (values: any) => {
    const data = values as IUISelectItem;
    callbackRef.current(data, data.price);
    onClose();
  };

  useImperativeHandle(ref, () => ({
    open: onOpen,
  }));
  return (
    <Modal
      open={visible}
      title='EDIT PRICE'
      footer={null}
      width={'1200px'}
    >
      <Container onFinish={handleFinish} form={form} initialValues={{ price: 0, itemName: 'Quick Pay' }}>
        <ServiceName className='ServiceName'>
          <Text content_content_2_16_medium color_text_3 text_center style={{ fontSize: 20 }}>
            Service Name:
          </Text>
          <Form.Item noStyle name={'itemName'}>
            <Input disabled className='service-name-input' size='small' />
          </Form.Item>
        </ServiceName>
        <Text content_content_2_16_medium color_text_3 text_center style={{ fontSize: 20 }}>
          Enter Amount:
        </Text>
        <Form.Item noStyle name={'price'}>
          <DollarAmountInput
            ref={inputRef}
            className='CurrencyInput'
            inputMode='none'
            autoFocus
            color='#D2464F'
            maxValue={1000}
          />
        </Form.Item>
        <Form.Item noStyle name={'price'}>
          <DollarAmountKeyboard
            controlRef={inputRef}
            maxValue={1000}
          />
        </Form.Item>
        <div className="footer-container">
          <button onClick={onClose} type='button' className="btn btn-close"><span>Close</span></button>
          <button onClick={onClear} type='button' className="btn btn-clear"><span>Clear</span></button>
          <button type='submit' className="btn btn-done"><span>Ok</span></button>
        </div>
      </Container>
    </Modal >
  );
});
ModalEditPriceItem.displayName = 'ModalEditPriceItem';
export default ModalEditPriceItem;
const ServiceName = styled.div`
  margin-bottom: 1.5rem;
`;
const Container = styled(Form)`
.header-container {
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  background: #232F3E;
  span {
    color: #FFF;
    text-align: center;
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
}
.modal-label {
  color: #64748B;
  text-align: center;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.ServiceName {
  padding-top: 24px;
}
.ant-input.service-name-input {
  color: #1D2129;
  text-align: center;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  text-transform: capitalize;
  border: none;
  outline: none;
}

.CurrencyInput {
  justify-content: center;
  margin-bottom: 16px;
  input {
    border: none;
    box-shadow: none;
    text-align: center;
  }
  .fake-labels, input, .mock-cursor  {
    font-size: 50px;
    font-weight: 600;
  }
}

.footer-container {
  display: flex;
  padding: 0px 16px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  padding-bottom: 40px;
  button.btn {
    display: flex;
    height: 70px;
    padding: 16px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 4px;
    background: #E5E6EB;
    box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;
    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    &.btn-issue-gift-card {
      border-radius: 4px;
      background: #C6E9EF;
      box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #6FABB6 inset;
    }
    &.btn-clear {
      border-radius: 4px;
      background: #C6E9EF;
      box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #6FABB6 inset;
    }

    &.btn-clear {
      border-radius: 4px;
      background: #FCFCFD;
      box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;
    }

    &.btn-done {
      border-radius: 4px;
      background: #FF8890;
      box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -4px 0px 0px #E7646D inset;
    }
  }
}
`;
